export const environment = {
  appName: 'BIOMAF',
  production: false,
	version: 'uat',
  api: {
    baseUrl: 'https://biomaf.uat.test.irevolution-group.com/api',
  },
  featureFlags: {
    enableItems: true,
  }
} as const;
